import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import Checkbox from '../Checkbox'; // only allow checkbox to catch event to prevent firing anchor when using getRowLink

var stopPropagation = function stopPropagation(originalEvent) {
  return function (event) {
    event.stopPropagation();

    if (originalEvent) {
      originalEvent(event);
    }
  };
};

function CheckboxCell(_ref) {
  var onClick = _ref.onClick,
      onKeyDown = _ref.onKeyDown,
      restProps = _objectWithoutPropertiesLoose(_ref, ["onClick", "onKeyDown"]);

  return /*#__PURE__*/React.createElement(Checkbox, _extends({
    size: "lg",
    label: null,
    onClick: stopPropagation(onClick),
    onKeyDown: stopPropagation(onKeyDown)
  }, restProps));
}

export default CheckboxCell;